import React from 'react';
import { Animated, StyleSheet } from 'react-native';

import { ITEM_HEIGHT, WAIT_FOR_LONGPRESS_MS, SNAPTO_ANIMATION_DURATION } from '../constants';


const styles = StyleSheet.create({
  itemText: {
    color: 'black', textAlign: 'center', justifyContent: 'center',
  },
  box: {
    flex: 1, height: '100%', alignItems: 'center', justifyContent: 'center',
  },
});


const renderItem = ({ item }) => (
  <Animated.View style={styles.box}>
    <Animated.Text style={styles.itemText}>{item.id}</Animated.Text>
  </Animated.View>
);

export const defaults = {
  data: [],
  onReorder: () => {
    console.warn('DraggableFlatList: Specify onReorder({ fromIndex, toIndex }) callback to restructure your data after drag-and-drop');
  },
  itemHeight: ITEM_HEIGHT,
  waitForLongPressMs: WAIT_FOR_LONGPRESS_MS,
  snapToAnimationDuration: SNAPTO_ANIMATION_DURATION,
  renderItem,
};

export const DraggableFlatListContext = React.createContext(defaults);

export default DraggableFlatListContext;
